import VueRouter, { RawLocation, Route } from 'vue-router';
import { objectIncludes, objectsMatch } from '../utils/objectCompare';

const trailingSlashRE = /\/?$/;

export function isExactPath(current: Route, target: Route): boolean {
  return (
    current.path.replace(trailingSlashRE, '/') ===
    target.path.replace(trailingSlashRE, '/')
  );
}

export function includesPath(current: Route, target: Route): boolean {
  return (
    current.path
      .replace(trailingSlashRE, '/')
      .indexOf(target.path.replace(trailingSlashRE, '/')) === 0
  );
}

export function matchesHash(current: Route, target: Route): boolean {
  return !target.hash || current.hash === target.hash;
}

export function matchesQuery(
  current: Route,
  target: Route,
  exact = false,
): boolean {
  if (exact) {
    return objectsMatch(current.query, target.query);
  }
  return objectIncludes(current.query, target.query);
}

export function isSameRoute(current: Route, target: Route): boolean {
  return (
    isExactPath(current, target) &&
    matchesHash(current, target) &&
    matchesQuery(current, target, true)
  );
}

export function isIncludedRoute(current: Route, target: Route): boolean {
  return (
    includesPath(current, target) &&
    matchesHash(current, target) &&
    matchesQuery(current, target)
  );
}

export function isCurrentRoute(
  router: VueRouter,
  location: RawLocation,
  current?: Route,
  exact = false,
): boolean {
  const route = current || router.currentRoute;
  if (!route) {
    return false;
  }
  const { route: resolved } = router.resolve(location, route);
  if (exact) {
    return isSameRoute(route, resolved);
  }
  return isIncludedRoute(route, resolved);
}
